import React, { Fragment } from "react";
import Header from "../../components/Header/Header";
import HeroSection from "../../components/Hero-Section/HeroSection";
import CompanySection from "../../components/Company-section/Company";
import About from "../../components/About-us/About";
import ChooseUs from "../../components/Choose-us/ChooseUs";
import Features from "../../components/Feature-section/Features";
import Newsletter from "../../components/Newsletter/Newsletter";
import Footer from "../../components/Footer/Footer";
import Workshops from "../../components/Workshops-section/Workshops";
import FeaturedBlogPostsList from "../../components/Blog-Sections/Posts/featured-blogs";
import FeaturedCourses from "../../components/Courses-section/FeaturedCourses";
import HeadSection from "../../components/meta";
import { MODEL } from "../../model";
import BannerAd from "../../components/Ads/bannerAd";

const Home = () => {
  const structuredData = {
    "@context": "https://schema.org",
    "@type": "WebPage",
    name: "SEED TO TREE: Tech Academy & Solutions",
    description:
      "Seed to Tree: Where education meets innovation. Top-tier academy & software house.",
    url: MODEL.app.base_url,
  };

  return (
    <Fragment>
      <HeadSection
        title={"HOME"}
        keywords={""}
        addPostFixTitle={true}
        largeTwitterCard={true}
        showCanonical={true}
        content={"Home page of seed to tree academy website."}
        link={`${MODEL.app.base_url}`}
      >
        <script
          type="application/ld+json"
          dangerouslySetInnerHTML={{ __html: JSON.stringify(structuredData) }}
        />
      </HeadSection>
      <Header isActive="home" />
      <HeroSection />
      <About id="about" />
      <BannerAd />
      <CompanySection />
      <FeaturedCourses id="featured-courses" />
      <Workshops id="workshops" />
      <FeaturedBlogPostsList />
      <ChooseUs id="whyUs" />
      <Features />
      <Newsletter />
      <BannerAd />
      <Footer />
    </Fragment>
  );
};

export default Home;
